import React from "react";
import { comparer, toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { useFormContext } from "../Form";
import { createUseStyles } from "react-jss";
export const SelectTableRowCheckbox = observer(({ id, label, name, invert = false }) => {
    const { values } = useFormContext();
    const handleChange = React.useCallback((e) => {
        let collection = toJS(values.get(name)) || [];
        if ((e.target.checked && !invert) || (!e.target.checked && invert)) {
            collection.push(id);
        }
        else {
            collection = collection.filter((item) => item !== id);
        }
        values.set(name, collection);
    }, [values, name, id, invert]);
    const getValue = values
        .get(name)
        .find((item) => comparer.structural(item, id));
    const getChecked = () => (invert ? !getValue : !!getValue);
    const classes = useCheckboxLabelClasses();
    return (React.createElement("label", { className: classes.label },
        React.createElement("input", { name: id, id: id, type: "checkbox", onChange: handleChange, checked: getChecked() }),
        React.createElement("span", { className: "sr-only" }, label)));
});
const useCheckboxLabelClasses = createUseStyles({
    label: {
        width: 30,
        paddingLeft: 9,
        paddingTop: 7,
        paddingBottom: 3,
        marginBottom: "0px !important",
    },
});
